import type { PageableResponse } from '../types';
import type { Room, RoomListRequest } from './types';
import { api } from '../api';

export const roomsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRooms: build.query<PageableResponse<Room>, RoomListRequest>({
      query: (params = {}) => ({
        url: '/rooms',
        params: {
          ...params,
        },
      }),
      keepUnusedDataFor: 30,
      providesTags: ['Rooms'],
    }),
  }),
});

export const { useGetRoomsQuery } = roomsApi;
